/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
enum Licenses {
  None = 0,
  //
  TimeProfessional = 1,
  TimeEnterprise = 2,
  //
  ReadOnlyProfessional = 4,
  ReadOnlyEnterprise = 8,
  //
  TotalETOProfessional = 16,
  TotalETOEnterprise = 32,
}

export default Licenses;
